import Header from '../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../utils/Loader';
import { useGetStudentExamResultQuery} from "../../Services/api";
import {pageUrl,pageSize} from "../../utils/constants/constants";
import "../../assets/niceapms/assets/css/style.css"
import {Link, useParams } from 'react-router-dom';
import parse from 'html-react-parser';

export default function StudentMocKExamResult() {   
    
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const {
        data: studentExamResult,
        isLoading: isGetLoading,
      } = useGetStudentExamResultQuery({ params:  {search,page,pageSize}  });
      
      const getPrevious= () => {
        setPage(page-1);
        setSearch("");
      }
      const getNext=()=>{
        setPage(page+1);
        setSearch("");
      }
      const findSearch=(e)=>{
        setPage(0);
        setSearch(e.target.value);
      }
    if(isGetLoading ) return  <Loader />
   
    return (
            <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Mock Exam Result</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                        <li className="nav-item flex-fill" role="presentation">
                            <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Mock Exam Result</button>
                        </li>
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                   <div className='col-md-12 col-sm-12 col-xs-12 '>
                                        <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th className='text-capitalize'>student</th>
                                                        <th className='text-capitalize'>course name</th>
                                                        <th className='text-capitalize'>Download Result</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    
                                                {

                                                    studentExamResult?.data?.data_array?.map((item,index) => {
                                                        
                                                    return (
                                                        <tr key={index}>
                                                            <th scope="row">{index+1}</th>
                                                            <td>{item?.student?.first_name} {item?.student?.last_name} </td>
                                                            <td>{item?.course?.course_name}</td>
                                                           
                                                            <td><Link style={{'fontSize':'12px'}} to={item.file} className="btn btn-dark">Download Result</Link></td>
                                                            
                                                        </tr>                                            
                                                        )  
                                                    })  
                                                } 
                                        </tbody>
                                        </table>                        
                                        <nav aria-label="Page navigation example">
                                            <ul className="pagination">
                                            {studentExamResult?.data?.currentPage !==0 ? <li className="page-item"><button type="button" className="page-link" onClick={getPrevious}>Previous</button></li> :''}
                                            <li className="page-item"> {studentExamResult?.data?.currentPage+1} </li>                                                  
                                            <li className="page-item"> of {studentExamResult?.data?.totalPages}</li>
                                            {studentExamResult?.data?.currentPage !==studentExamResult?.data?.totalPages ? <li className="page-item"><button type="button" className="page-link" onClick={getNext}>Next</button></li>:''}
                                            </ul>
                                        </nav>
                                        
                                   </div>

                                  
                                </div>
                            </section>  
                        </div>
                    </div>
                </div>
            </div>
            </main>
        </div>
    );
}
